export * from './hook';
import { type State as StateType } from './reducer';

export type State<T> = StateType<T>;
